import type { FilteringService } from '.';

import { Environment } from '../../../environments/environment';

export function HasFilters(this: FilteringService, includeMap = true): boolean {
  return (
    this.areas().length > 0 ||
    this.baths().length > 0 ||
    this.beds().length > 0 ||
    this.dreamHomes() ||
    this.garages().length > 0 ||
    this.homesites().length > 0 ||
    this.includePendingSales() ||
    (includeMap && this.lat() !== Environment.mapCenter[1]) ||
    (includeMap && this.lng() !== Environment.mapCenter[0]) ||
    (includeMap && this.lvl() !== Environment.mapZoom) ||
    this.minSqft() !== '' ||
    this.models().length > 0 ||
    this.openHomes() ||
    this.pool() ||
    this.priceHigh() !== '' ||
    this.priceLow() !== '' ||
    this.reps() !== '' ||
    this.saleTypes() !== 'new,preowned' ||
    this.search().length > 0 ||
    this.series().length > 0 ||
    this.uliKey() !== '' ||
    this.unit().length > 0
  );
}
